import {required} from "vuelidate/lib/validators";  
import moment from 'moment'; 
const StrRiskGiris = {
    data() {
      return {  
        RiskDurumlari:[],
        StrRiskDeger:[],
        StrRiskDegerGiris:[],
        StrRiskGirisData:{ 
          Id:"",
          Risk:"",
          RiskPuani:"",
          MevcutKontroller:"", 
          YonlendiriciKontroller:"", 
          OnleyiciKontroller:"", 
          DuzelticiKontroller:"",
          SaptayiciKontroller:"",
          Etki:"", 
          Olasilik:"", 
          KayitTarihi:moment(new Date()).format('YYYY-MM-DD'), 
          RiskId:"", 
          DonemId:"", 
          DurumId:"",   
          BirimId:null, 
          Deleted: false,
          BaslamaTarihi: "",
          BitisTarihi: "",
        }, 
        FormDataType:  {
          Risk:{FieldName:"Risk",Field:"textarea",FieldTitle:this.$t('StrRiskGiris.AddEdit.Risk'),Disabled:"disabled"},
          MevcutKontroller:{FieldName:"MevcutKontroller",Field:"textarea",FieldTitle:this.$t('StrRiskGiris.AddEdit.MevcutKontroller')},
       //   YonlendiriciKontroller:{FieldName:"YonlendiriciKontroller",Field:"textarea",FieldTitle:this.$t('StrRiskGiris.AddEdit.YonlendiriciKontroller')},
       //   OnleyiciKontroller:{FieldName:"OnleyiciKontroller",Field:"textarea",FieldTitle:this.$t('StrRiskGiris.AddEdit.OnleyiciKontroller')},
          RiskPuani:{FieldName:"RiskPuani",Field:"input",FieldTitle:this.$t('StrRiskGiris.AddEdit.RiskPuani'),Disabled:"disabled"}, 
       //   DuzelticiKontroller:{FieldName:"DuzelticiKontroller",Field:"textarea",FieldTitle:this.$t('StrRiskGiris.AddEdit.DuzelticiKontroller')},
       //   SaptayiciKontroller:{FieldName:"SaptayiciKontroller",Field:"textarea",FieldTitle:this.$t('StrRiskGiris.AddEdit.SaptayiciKontroller')},
          BaslamaTarihi:{FieldName:"BaslamaTarihi",Field:"date",FieldTitle: this.$t('StrRiskGiris.AddEdit.BaslamaTarihi')},
          BitisTarihi:{FieldName:"BitisTarihi",Field:"date",FieldTitle: this.$t('StrRiskGiris.AddEdit.BitisTarihi')},
        
        } ,

      }
    },
    validations:{  
      FormData: {
        Risk:{},
        MevcutKontroller: {  }, 
    /*    YonlendiriciKontroller: {  }, 
        OnleyiciKontroller: {  },
        DuzelticiKontroller:{ },
        SaptayiciKontroller:{ }, */
        RiskPuani:{},
        BaslamaTarihi: {},
        BitisTarihi: {},
        DurumId:{ required},
      }
 
  },
  created(){
    this.ActionsSabitGet(1557).then(res => {  this.RiskDurumlari = res.Data });

  this.DegerTablosuOku();
  
  this.RiskGirisOku();
  },
  methods: {

    RiskGirisOku(){
        let Page= {
          PageNumber: "1",
          PageSize: "9999"
      }

          this.ActionsGet({"Service":"StrRiskGiris","Page":Page}).then(res => { 
            this.StrRiskDegerGiris = res.Data  
          }); 

      },

      DegerTablosuOku(){
        let Page= {
          PageNumber: "1",
          PageSize: "9999"
      }
        this.ActionsGet({"Service":"StrRiskDeger","Page":Page}).then(res => { 
          this.StrRiskDeger = res.Data  
        }); 
      }
    
  },

}
export default StrRiskGiris